





















import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { MultipleSelect } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { NormsServices } from '../../norms/api/NormsServices';
import { formatDate, formattedDate, parseFloatNumber } from '../../core/utils';
import { SettingsService } from '../api/SettingsService';
import Loading from 'vue-loading-overlay';
import Input from '../../core/components/Input.vue';
import { ParameterValueItem, VehicleProperties } from '../../core/models/Vehicle';
@Component({
    components: { MultipleSelect, Loading, SimpleTable, SectionTitle, Input }
})
export default class ListParameterValue extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: -1}) vehicleId: number;
    @Prop({default: {}}) vehicleProperties: VehicleProperties;
    @Prop({default: true}) vehicleHasActiveNorm: boolean;
    headers: Array<object> = [
        {
            text: 'Variable',
            align: 'left',
            value: 'variable_description'
        },
        {
            text: 'Variable ID',
            align: 'center',
            value: 'variable_id'
        },
        {
            text: 'Valor',
            align: 'center',
            value: 'value'
        },
        {
            text: 'Tipo de Valor',
            align: 'center',
            value: 'value_type',
            formatter: this.parseValueType
        },
        {
            text: 'Ecu address',
            align: 'center',
            value: 'ecu_address'
        },
        {
            text: 'Parameter ID',
            align: 'center',
            value: 'parameter_id'
        },
        {
            text: 'Última Modificación',
            align: 'center',
            value: 'timestamp',
            formatter: this.parseDate,
            width: '200px'
        },
        {
            text: 'Estado',
            align: 'center',
            value: 'status',
            formatter: this.parseStatus
        },
    ];
    vehicleWithoutActiveNormMsg: string = 'Este vehículo no tiene una Versión de Norma activa.';
    items: Array<ParameterValueItem> = [];
    search: string = '';
    pendingRequest: boolean = false;
    sectionTitle: string = 'Listado de Parameter Values';
    noDataText: string = 'No hay parameter values para mostrar';

    parseDate(value){
        return formattedDate(value, true)
    }

    parseValueType(rowValue){
        return this.vehicleProperties.parameter_values_types[rowValue]
    }

    parseStatus(rowStatus){
        return this.vehicleProperties.status_choices[rowStatus]
    }

    get vehicleHasNormActive(){
        return this.vehicleHasActiveNorm
    }

    setTableItems(items: Array<ParameterValueItem>){
        this.items = items;
    }

    loadingTable(value: boolean){
        this.pendingRequest = value;
    }

    getParameterValueItems(){
        this.setTableItems([]);
        //Solo llamo al WS si el vehiculo tiene una version de norma activa
        if(this.vehicleHasNormActive){
            this.loadingTable(true);
            SettingsService.listParameterValue(
                this.vehicleId
            ).then((res: Array<ParameterValueItem>) => {
                this.loadingTable(false);
                this.setTableItems(res);
            }).catch((error) => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo obtener el listado de Parameter Value'
                });
                this.loadingTable(false);
            })
        }
    }

    created(){
        this.getParameterValueItems();
    }

}
